module.exports = __webpack_public_path__ + "static/img/marble-dark.b55bfce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/marble-dark.jpg
// module id = ADHT
// module chunks = 0